/* eslint-disable arrow-body-style */
import { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Modal,
} from '@mui/material';
import { StyledModalBox } from '../../blogs/styles';
import EventNewEditForm from 'src/sections/@dashboard/event/EventNewEditForm';
import { Event } from '../../../../@types/event';

type EventModalProps = {
  open: boolean;
  // `saved` = the program as stored after a successful save (undefined when
  // the editor was closed without saving).
  handleClose(saved?: Event): void;
  isEdit: boolean;
  currentEvent: Event | undefined;
};

// R4-E7: Esc or a click outside used to close the editor and silently throw
// away every unsaved edit (and an upload still on its way). Now, when the form
// reports unsaved changes, those ask first; the form's own close after a
// successful save does not.
export const EventModal = ({ open, handleClose, isEdit, currentEvent }: EventModalProps) => {
  const [dirty, setDirty] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      setDirty(false);
      setConfirmOpen(false);
    }
  }, [open]);

  const onDirtyChange = useCallback((next: boolean) => setDirty(next), []);

  return (
    <>
      <Modal
        open={open}
        onClose={(_event, reason) => {
          if ((reason === 'backdropClick' || reason === 'escapeKeyDown') && dirty) {
            setConfirmOpen(true);
            return;
          }
          handleClose();
        }}
      >
        <StyledModalBox>
          <EventNewEditForm
            handleClose={handleClose}
            isEdit={isEdit}
            currentEvent={currentEvent}
            onDirtyChange={onDirtyChange}
          />
        </StyledModalBox>
      </Modal>

      <Dialog open={open && confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs">
        <DialogTitle>Discard your changes to this program?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Nothing you changed here has been saved yet. An upload still on its way is dropped too.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => setConfirmOpen(false)}>
            Keep editing
          </Button>
          <Button
            color="error"
            onClick={() => {
              setConfirmOpen(false);
              handleClose();
            }}
          >
            Discard
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
